import { useEffect, useState } from "react";
import { Phone, MessageSquare } from "lucide-react";
import { SITE } from "../lib/site";

/**
 * Sticky bottom Call/Text bar for mobile — hidden on md+.
 * Fades in after slight scroll so it doesn't cover the hero.
 */
export default function StickyCallCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed inset-x-0 bottom-0 z-40 transition-transform duration-500 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
      role="region"
      aria-label="Quick contact"
      data-testid="mobile-sticky-cta"
    >
      <div className="mx-3 mb-3 rounded-full bg-[#0A192F] border border-[#C5A059]/40 shadow-2xl p-1.5 flex items-center gap-2">
        <a
          href={SITE.phoneHref}
          className="flex-1 h-11 rounded-full bg-[#C5A059] text-[#0A192F] font-medium text-sm flex items-center justify-center gap-2"
          data-testid="sticky-call"
        >
          <Phone className="w-4 h-4" /> Call Now
        </a>
        <a
          href={SITE.smsHref}
          className="flex-1 h-11 rounded-full border border-white/25 text-white text-sm flex items-center justify-center gap-2"
          data-testid="sticky-text"
        >
          <MessageSquare className="w-4 h-4" /> Text
        </a>
      </div>
    </div>
  );
}
